import { render, staticRenderFns } from "./TheSvgInlineResource.vue?vue&type=template&id=05c52509&scoped=true&"
import script from "./TheSvgInlineResource.vue?vue&type=script&lang=js&"
export * from "./TheSvgInlineResource.vue?vue&type=script&lang=js&"
import style0 from "./TheSvgInlineResource.vue?vue&type=style&index=0&id=05c52509&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c52509",
  null
  
)

export default component.exports